import { create } from "zustand";
import { verifyRequest } from "./authService";

type AdminRole = "admin" | "billing_viewer";

type AuthStore = {
  isVerified: boolean;
  adminRole?: AdminRole;
  verifyLogin: () => Promise<boolean>;
  setAdminRole: (role: AdminRole) => void;
};

export const useAuthStore = create<AuthStore>((set) => ({
  isVerified: false,
  adminRole: undefined,
  verifyLogin: async () => {
    const response = await verifyRequest();
    set({ isVerified: true, adminRole: response.role });

    return true;
  },
  setAdminRole: (role: AdminRole) => {
    set({ adminRole: role });
  },
}));
